import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service7Second = () => {
       return (
           <div className="about-events-main-container"> {/* Main outer container */}
               <div className="about-events-container2">
                   <div className="about-events-wrapper"> {/* Flexbox container */}
                       <div className="about-events-content2">
                           <h2 className="about-header-service2">Accommodation Package Details</h2>
                           <p className="about-events-description2">
                               We are pleased to offer 7 luxurious rooms in our residence for your stay, designed with comfort and elegance in mind. You can customize your accommodation based on your preferences:<br/><br/>
                                </p>
                           <h2 className="about-subheader-service2">Accommodation Options:</h2>
                                                   <ul className="about-events-list2">
                                                 <li>  <strong>Full Board:</strong> Enjoy breakfast, lunch, and dinner for a seamless experience.</li>
                                                   <li><strong>Half Board:</strong> Includes breakfast and dinner.</li>
                                                 <li> <strong>Bed and Breakfast:</strong> A perfect option for those who prefer flexibility with lunch and dinner on their own.</li>
                                                 </ul>


                           <ul className="about-events-list2">
                           <h2 className="about-subheader-service2">Booking Information:</h2>
                               <li>- A 50% advance is required at the time of reservation to confirm your booking.</li>

                           </ul>
                       </div>

                       <div className="about-events-grid2">
                           <div className="about-events-images2">
                               <img
                                   src={`${process.env.PUBLIC_URL}/images/accomedartion.webp`}
                                   className="service2-images3"
                                 
                               />
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       );
   };
export default Service7Second;
